<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 pt-2 d-flex flex-column gap-1">
        <span [innerHTML]="displayText | placeholderHighlight: editor"></span>
        <div class="d-flex flex-wrap gap-1" *ngIf="ppr?.affectedForms?.length">
          <span>Active forms found for the</span>
          <span class="bold blue">{{ resource?.name?.trim() }}</span>
          <document-chips [documentChips]="ppr?.affectedForms"></document-chips>
        </div>
        <div class="d-flex flex-column gap-1" *ngIf="ppr && validateRS">
          <span>Is a radiation survey required?</span>
          <mat-radio-group
            [value]="ppr.radSurveyAffectedForms.length ? 'yes' : 'no'"
            class="d-flex align-items-center gap-2"
          >
            <mat-radio-button value="yes" [disabled]="true" color="primary"
              >Yes</mat-radio-button
            >
            <document-chips
              *ngIf="ppr.radSurveyAffectedForms.length"
              [documentChips]="ppr.radSurveyAffectedForms"
              [isRadSurvey]="true"
            ></document-chips>
            <mat-radio-button value="no" [disabled]="true" color="primary"
              >No</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
      <div class="col-2 d-flex flex-row justify-content-end align-items-center suggestion-anchor">
        <mat-icon-with-tootip
          *ngIf="manual"
          (click)="reset()"
          class="warning-icon"
          color="accent"
          icon="warning"
          [toolTipText]="
            documents +
            '<br><span class=\'small\'>This checkbox was manually ' +
            (this.checked ? 'Checked' : 'Unchecked') +
            '<br>[Click to Reset!]</span>'
          "
          toolTipClass="accent-tooltip"
          toolTipPosition="left"
        ></mat-icon-with-tootip>

        <mat-checkbox-with-roles
          [checked]="checked"
          [disabled]="disabled"
          [labelPosition]="'before'"
          [roleCodes]="roleCodes"
          [user]="user"
          [warning]="moreInfo"
          (change)="checkboxChanged($event)"
          color="primary"
          *ngIf="checkboxVisible"
          [date]="date"
        >
        </mat-checkbox-with-roles>
        <!-- Automatic results recommend a manual signature instead of signing as ASCC. -->
        <mat-icon
          *ngIf="suggested && !checked && !disabled && checkboxVisible"
          class="suggestion-icon"
          [matTooltip]="suggestionTooltip"
          matTooltipPosition="above"
          >lightbulb</mat-icon
        >
      </div>
    </div>
  </div>
</div>
